export default __webpack_public_path__ + "static/media/2318.dff46b44.png";